import React, { useState, useEffect } from 'react';

// Sample Data (to simulate fetching data from a server)
const alumniData = [
  { id: 1, name: 'John Doe', role: 'Geotechnical Engineer', year: 2015, location: 'New York', profilePic: 'https://via.placeholder.com/150' },
  { id: 2, name: 'Jane Smith', role: 'Environmental Consultant', year: 2017, location: 'California', profilePic: 'https://via.placeholder.com/150' },
  { id: 3, name: 'Sam Green', role: 'Software Developer', year: 2016, location: 'Texas', profilePic: 'https://via.placeholder.com/150' },
  // Add more data as needed
];

function Alumni() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredAlumni, setFilteredAlumni] = useState(alumniData);
  const [sortOrder, setSortOrder] = useState('asc');
  const [pagination, setPagination] = useState({ currentPage: 1, itemsPerPage: 5 });

  useEffect(() => {
    filterAlumni();
  }, [searchTerm, sortOrder]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSortChange = () => {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  const filterAlumni = () => {
    const filtered = alumniData.filter((alumni) => 
      alumni.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      alumni.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
      alumni.location.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (sortOrder === 'asc') {
        return a.name.localeCompare(b.name);
      } else {
        return b.name.localeCompare(a.name);
      }
    });

    setFilteredAlumni(sorted);
  };

  const handlePagination = (pageNum) => {
    setPagination({ ...pagination, currentPage: pageNum });
  };

  const currentAlumni = filteredAlumni.slice(
    (pagination.currentPage - 1) * pagination.itemsPerPage,
    pagination.currentPage * pagination.itemsPerPage
  );

  return (
    <div className="alumni-page">
      <style>{`
        .alumni-page {
          font-family: Arial, sans-serif;
          color: #333;
          padding: 20px;
        }

        .alumni-page h1 {
          font-size: 30px;
          color: #007BFF;
          text-align: center;
          margin-bottom: 20px;
        }

        .search-bar {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
          gap: 10px;
        }

        .search-bar input {
          padding: 10px;
          width: 100%;
          max-width: 300px;
          font-size: 16px;
          border-radius: 4px;
          border: 1px solid #ccc;
        }

        .search-bar button {
          padding: 10px 20px;
          font-size: 16px;
          background-color: #007BFF;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .alumni-list {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
        }

        .alumni-card {
          width: 250px;
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 15px;
          text-align: center;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
          position: relative;
          transition: transform 0.3s ease-in-out;
        }

        .alumni-card:hover {
          transform: scale(1.05);
        }

        .alumni-card img {
          width: 100%;
          height: 150px;
          border-radius: 50%;
          margin-bottom: 10px;
        }

        .alumni-card h3 {
          font-size: 18px;
          margin: 10px 0;
          color: #555;
        }

        .alumni-card p {
          font-size: 14px;
          color: #777;
        }

        .pagination {
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }

        .pagination button {
          padding: 5px 10px;
          font-size: 14px;
          margin: 0 5px;
          border: 1px solid #ddd;
          background-color: #fff;
          cursor: pointer;
        }

        .pagination button.active {
          background-color: #007BFF;
          color: white;
        }

        /* Media Queries for Mobile Responsiveness */
        @media (max-width: 768px) {
          .alumni-page h1 {
            font-size: 24px;
          }

          .alumni-list {
            flex-direction: column;
            align-items: center;
          }

          .alumni-card {
            width: 90%;
            max-width: 400px;
          }

          .search-bar input {
            width: 100%;
          }

          .pagination button {
            padding: 5px 10px;
            font-size: 12px;
          }
        }

        @media (max-width: 480px) {
          .alumni-page h1 {
            font-size: 20px;
          }

          .alumni-card {
            width: 90%;
            max-width: 350px;
          }

          .search-bar input {
            width: 80%;
          }

          .pagination button {
            font-size: 10px;
            padding: 3px 6px;
          }
        }

      `}</style>

      <h1>Alumni</h1>

      {/* Search Bar */}
      <div className="search-bar">
        <input 
          type="text" 
          placeholder="Search alumni by name, role, or location"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <button onClick={handleSortChange}>Sort {sortOrder === 'asc' ? 'A-Z' : 'Z-A'}</button>
      </div>

      {/* Alumni List */}
      <div className="alumni-list">
        {currentAlumni.map((alumni) => (
          <div key={alumni.id} className="alumni-card">
            <img src={alumni.profilePic} alt={alumni.name} />
            <h3>{alumni.name}</h3>
            <p>{alumni.role}</p>
            <p>{alumni.location}</p>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination">
        {Array.from({ length: Math.ceil(filteredAlumni.length / pagination.itemsPerPage) }, (_, index) => (
          <button
            key={index}
            className={pagination.currentPage === index + 1 ? 'active' : ''}
            onClick={() => handlePagination(index + 1)}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Alumni;
